import { Component, DestroyRef, OnInit, inject, input, output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {loadTriggerLeft} from '../animations/main.animations';
import {ModalService} from '../modal/modal.service';
import {FormAddArticleComponent} from '../forms/form-add-article/form-add-article.component';
import {ConfirmComponent} from '../modal/confirm/confirm.component';
import {ArticlesService} from '../../services/articles.service';
import {EditingService} from '../../services/editing.service';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { NgStyle, NgClass, AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-animated-article-left',
    templateUrl: './animated-article-left.component.html',
    styleUrls: ['./animated-article-left.component.scss'],
    animations: [loadTriggerLeft],
    imports: [NgStyle, NgClass, AsyncPipe]
})
export class AnimatedArticleLeftComponent implements OnInit {
  private modal = inject(ModalService);
  private articleService = inject(ArticlesService);
  private editService = inject(EditingService);
  private storage = inject(AngularFireStorage);
  private destroyRef = inject(DestroyRef);

  readonly editMode = this.editService.editMode;

  type;
  image;
  imageUrl;
  readonly article = input.required<any>();
  readonly deleted = output<string>();

  ngOnInit() {
    this.type = this.article().type;
    this.getImage();
  }

  editArticle() {
    this.modal.open(FormAddArticleComponent, {data: {title: 'Edit Article', content: this.article(), type: this.type}})
      .afterClosed.pipe(takeUntilDestroyed(this.destroyRef)).subscribe( response => {
      this.articleService.saveArticles(response);
    });
  }

  deleteArticle() {
    this.modal.open(ConfirmComponent, {data: {message: 'Delete this article?'}})
      .afterClosed.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(confirmed => {
        if (!confirmed) {
          return;
        }
        this.articleService.deleteArticle({type: this.type, id: this.article().id})
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(() => this.deleted.emit(this.article().id));
      });
  }

  getImage() {
    const article = this.article();
    if (article.attributes.image != null) {
      const ref = this.storage.ref(article.attributes.image);
      this.image = ref.getDownloadURL();
    } else if (article.attributes.fileLink != null) {
      this.image = article.attributes.fileLink;
    }
  }

}
